import { useFormik } from "formik";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../../../components/buttons/button";
import { TextInput } from "../../../components/inputs/textInput";
import { OtpCountdownTImer } from "../../../components/timer/OtpCountdownTimer";
import { HeaderSubheader } from "../../../components/typography/headerSubheader";
import {
  useResendVerificationCodeMutation,
  useVerifyAccountMutation,
} from "../../../redux/features/auth/auth.api";
import { confirmEmailSchema } from "../../../validationSchema";

export const SignUpConfirmEmail = () => {
  const [searchParams] = useSearchParams();

  const [resendAccountVerificationCode] = useResendVerificationCodeMutation();

  const [verifyAccount, { isLoading: verifying }] = useVerifyAccountMutation();

  const navigate = useNavigate();

  const {
    values,
    errors,
    isValid,
    touched,
    handleChange,
    handleSubmit,
    handleBlur,
    setFieldValue,
  } = useFormik({
    initialValues: {
      code: "",
      email: searchParams.get("email") || "",
    },
    validationSchema: confirmEmailSchema,
    onSubmit: async (data) => {
      const payload = {
        Code: data.code,
        Email: data.email,
      };

      const resp = await verifyAccount({ ...payload });

      if (resp.data?.success) {
        navigate("/auth/sign-in");
      }
    },
  });

  useEffect(() => {
    setFieldValue("email", searchParams.get("email") || "");
    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <div className="w-full">
      <HeaderSubheader
        header="Confirm Email"
        subheader={
          <div>
            We sent a code to{" "}
            <span className="text-pry-dark-green-300/80 font-medium">
              {values.email}
            </span>
          </div>
        }
      />

      <form className="mt-6 flex flex-col gap-3" onSubmit={handleSubmit}>
        <TextInput
          type="text"
          name={"code"}
          value={values.code}
          placeholder="Enter code"
          onChange={handleChange}
          onBlur={handleBlur}
          errors={errors?.code && touched?.code ? errors?.code : ""}
          hasIcon={false}
        />

        <p className="w-full text-left !text-xs text-grey-200">
          Didn’t get any code?{" "}
          <OtpCountdownTImer
            text="Resend Code"
            onClick={async () => {
              const payload = {
                Email: values.email,
              };
              await resendAccountVerificationCode(payload);
            }}
          />
        </p>

        <div className="w-full text-right mt-5 md:mt-3">
          <Button
            text="Confirm Email"
            type="submit"
            loading={verifying}
            disabled={!isValid || verifying}
          />
        </div>
      </form>
    </div>
  );
};
